import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Field } from 'formik';
import AddressComponent from '../AddressComponent';

import Select from 'react-select';

export default function ServiceLocation({ errors, touched, values, handleBlur, handleChange, successMsg, errorMsg,
    handleServiceTypeChange, serviceTypes, setFieldValue, defaultServiceTypes, prefix, dispatch }) {

    return (
        <div className="w-full space-y-6">
            {/* Location Name Field */}
            <div>
                <label htmlFor="input_location_name" className="block text-sm font-medium text-gray-700 mb-2">
                    Name <span className="text-red-500">*</span>
                </label>
                <div>
                    <Field 
                        type="text" 
                        id="input_location_name" 
                        name="locationName" 
                        required
                        className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent ${
                            errors.locationName && touched.locationName 
                                ? 'border-red-500 bg-red-50' 
                                : 'border-gray-300'
                        }`} 
                    />
                    {errors.locationName && touched.locationName ? (
                        <div className="mt-1 text-sm text-red-600">{errors.locationName}</div>
                    ) : null}
                </div>
            </div>

            {/* Address Component */}
            <div>
                <AddressComponent
                    errors={errors}
                    touched={touched}
                    values={values}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    prefix={prefix}
                />
            </div>

            {/* Service Types Multi-Select */}
            <div>
                <label htmlFor="pmsServiceType" className="block text-sm font-medium text-gray-700 mb-2">
                    Services <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                    <OverlayTrigger 
                        trigger={["hover", "focus"]} 
                        placement='right'
                        overlay={
                            <Tooltip id='tooltip-service-type'>
                                You can add multiple services by clicking on each service
                            </Tooltip>
                        }
                    >
                        <div>
                            <Select
                                isMulti
                                name="pmsServiceType"
                                options={serviceTypes}
                                defaultValue={defaultServiceTypes}
                                closeMenuOnSelect={false}
                                menuPlacement="top"
                                menuPosition="fixed"
                                menuPortalTarget={document.body}
                                maxMenuHeight={220}
                                onChange={selectedTypes => {
                                    handleServiceTypeChange(selectedTypes, setFieldValue, dispatch)
                                }}
                                handleBlur={handleBlur}
                                className={`basic-multi-select ${
                                    errors.pmsServiceType 
                                        ? 'border-red-500 rounded-md' 
                                        : ''
                                }`}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: errors.pmsServiceType 
                                            ? '#ef4444' 
                                            : state.isFocused 
                                                ? '#14b8a6' 
                                                : '#d1d5db',
                                        '&:hover': {
                                            borderColor: errors.pmsServiceType 
                                                ? '#ef4444' 
                                                : '#14b8a6',
                                        },
                                        boxShadow: state.isFocused 
                                            ? '0 0 0 3px rgba(20, 184, 166, 0.1)' 
                                            : 'none',
                                        borderRadius: '0.375rem',
                                    }),
                                    menuPortal: baseStyles => ({
                                        ...baseStyles,
                                        zIndex: 1060,
                                    }),
                                    menuList: baseStyles => ({
                                        ...baseStyles,
                                        scrollbarColor: '#6b7280 #e5e7eb',
                                        scrollbarWidth: 'auto',
                                        '&::-webkit-scrollbar': {
                                            width: '10px',
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            background: '#e5e7eb',
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            background: '#6b7280',
                                            borderRadius: '5px',
                                        },
                                    }),
                                }}
                            />
                        </div>
                    </OverlayTrigger>
                    {errors.pmsServiceType ? (
                        <div className="mt-1 text-sm text-red-600">
                            {typeof errors.pmsServiceType === 'string' 
                                ? errors.pmsServiceType 
                                : errors.pmsServiceType[0]?.label || 'Invalid selection'
                            }
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}